import './base-main'
import Vue from 'vue'
import Vuex from 'vuex'
import generalStore, { GENERAL_STORE } from './store'
import App from './App.vue'

const store = new Vuex.Store({ namespaced: true, modules: { generalStore } })

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')

// ________
// Обработка нажатия кнопки "рассчитать доставку" ведущая на эту же форму
const orderTypeHandler = e => {
  e.preventDefault()
  store.commit(`${GENERAL_STORE}/toggleModals`, 'chooseOrderType')
}

const baseUrl = window.location.origin

document.querySelectorAll(`[href="${baseUrl}/orderDelivery"`).forEach(el => {
  el.addEventListener('click', orderTypeHandler)
})
